var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 5.767H5.325L15.968 3.31 15.425.954A1.218 1.218 0 0013.97.03L.938 3.04c-.553.128-.93.622-.936 1.174H0l.003 10.224c0 .677.549 1.227 1.226 1.227h13.545c.677 0 1.226-.55 1.226-1.227l-.008-8.672zm-3.418-4.46l2.108 1.376-1.625.375-2.108-1.375 1.625-.376zm-3.278.758l2.107 1.376-1.625.375-2.107-1.375 1.625-.376zm-3.2.74L8.205 4.18l-1.625.375L4.472 3.18l1.625-.375zm-3.269.754l2.107 1.376-1.625.375-2.107-1.375 1.625-.376zm11.946 10.88H1.226V6.992h13.547v7.447z",
    fill: "#515864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.722 8.773v3.986l3.188-1.993-3.188-1.993z",
    fill: "#515864"
  })));
}
export default SvgVideo;